// source: src/common/person/trend_container.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_person_trend_pb = require('../../../src/common/person/trend_pb.js');
goog.object.extend(proto, src_common_person_trend_pb);
goog.exportSymbol('proto.loupe.common.person.TrendContainer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.person.TrendContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.person.TrendContainer.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.person.TrendContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.person.TrendContainer.displayName = 'proto.loupe.common.person.TrendContainer';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.person.TrendContainer.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.person.TrendContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.person.TrendContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.person.TrendContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.person.TrendContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
    trendsList: jspb.Message.toObjectList(msg.getTrendsList(),
    src_common_person_trend_pb.Trend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.person.TrendContainer}
 */
proto.loupe.common.person.TrendContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.person.TrendContainer;
  return proto.loupe.common.person.TrendContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.person.TrendContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.person.TrendContainer}
 */
proto.loupe.common.person.TrendContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new src_common_person_trend_pb.Trend;
      reader.readMessage(value,src_common_person_trend_pb.Trend.deserializeBinaryFromReader);
      msg.addTrends(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.person.TrendContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.person.TrendContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.person.TrendContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.person.TrendContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrendsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      src_common_person_trend_pb.Trend.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Trend trends = 1;
 * @return {!Array<!proto.loupe.common.person.Trend>}
 */
proto.loupe.common.person.TrendContainer.prototype.getTrendsList = function() {
  return /** @type{!Array<!proto.loupe.common.person.Trend>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_person_trend_pb.Trend, 1));
};


/**
 * @param {!Array<!proto.loupe.common.person.Trend>} value
 * @return {!proto.loupe.common.person.TrendContainer} returns this
*/
proto.loupe.common.person.TrendContainer.prototype.setTrendsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loupe.common.person.Trend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.person.Trend}
 */
proto.loupe.common.person.TrendContainer.prototype.addTrends = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loupe.common.person.Trend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.person.TrendContainer} returns this
 */
proto.loupe.common.person.TrendContainer.prototype.clearTrendsList = function() {
  return this.setTrendsList([]);
};


goog.object.extend(exports, proto.loupe.common.person);
